import {
  FluentProvider,
  DialogSurface,
  DialogContent,
  DialogActions,
  Dialog,
  DialogBody,
  DialogTitle,
  DialogTrigger,
} from '@fluentui/react-components';
import { useContext } from 'react';
import { BitButton } from '../BitButton';
import { QuotaContext } from '../../contexts/QuotaContext';
import { useAppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { app, monetization } from '@microsoft/teams-js';

export const QuotaPopup = () => {
  const appInsights = useAppInsightsContext();
  app.initialize();

  const { isQuotaPopupVisible, setIsQuotaPopupVisible } =
    useContext(QuotaContext);

  const openPurchaseExperience = () => {
    if (process.env.REACT_APP_APP_INSIGHTS !== '') {
      appInsights.trackEvent({ name: 'Upgrade from popup clicked' });
      if (monetization.isSupported()) {
        monetization
          .openPurchaseExperience()
          .catch(() =>
            window.open(
              encodeURI(
                'https://appsource.microsoft.com/en-us/product/web-apps/bitfractal1649005178126.dd1d8735-7a73-4914-929a-4f9fe0be6b75?tab=PlansAndPrice'
              )
            )
          );
      } else {
        window.open(
          encodeURI(
            'https://appsource.microsoft.com/en-us/product/web-apps/bitfractal1649005178126.dd1d8735-7a73-4914-929a-4f9fe0be6b75?tab=PlansAndPrice'
          )
        );
      }
    }
  };

  return (
    <FluentProvider>
      <Dialog
        open={isQuotaPopupVisible}
        onOpenChange={(event, data) => setIsQuotaPopupVisible(data.open)}
      >
        <DialogSurface>
          <DialogBody>
            <DialogTitle style={{ textAlign: 'center' }}>
              Ops! Your quota getting is over...
            </DialogTitle>
          </DialogBody>
          <DialogContent style={{ textAlign: 'center' }}>
            Don't worry, you can upgrade your plan right now by clicking bellow!
          </DialogContent>
          <DialogActions
            style={{
              marginTop: '1.2rem',
              justifyContent: 'center',
            }}
          >
            <BitButton
              label="Upgrade now"
              action={() => openPurchaseExperience()}
            />
            <DialogTrigger disableButtonEnhancement>
              <BitButton
                label="Close"
                variant="secondary"
                action={() => setIsQuotaPopupVisible(false)}
              />
            </DialogTrigger>
          </DialogActions>
        </DialogSurface>
      </Dialog>
    </FluentProvider>
  );
};
